(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nakis-apron-product"]) return;
  try {
    
  if (!customElements.get('nakis-apron')) {
    customElements.define('nakis-apron', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const form = this.querySelector('form');
        const hero = this.querySelector('.nk-apron__hero');
        const grid = this.querySelector('[data-models]');
        const more = this.querySelector('[data-more]');
        const logo = this.querySelector('[data-logo]');
        const phone = this.querySelector('[data-phone]');
        const button = this.querySelector('[type=submit]');
        const errorBox = this.querySelector('[data-error-box]');
        const selectModel = input => {
          hero.removeAttribute('srcset');
          hero.src = input.dataset.image;
          hero.alt = input.dataset.title;
          this.querySelector('[data-selected-caption]').textContent = input.dataset.title;
          this.querySelector('[data-selected-name]').textContent = input.dataset.title;
          this.querySelector('[data-model-property]').value = input.dataset.title;
          this.querySelector('[data-price]').textContent = input.dataset.price;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url);
        };
        form.addEventListener('change', event => {
          if (event.target.matches('input[name=id]')) selectModel(event.target);
        });
        if (more) more.addEventListener('click', () => {
          const expanded = !grid.hasAttribute('data-expanded');
          grid.toggleAttribute('data-expanded', expanded);
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? more.dataset.less : more.dataset.show;
        });
        const validateLogo = () => {
          const file = logo.files[0];
          const invalid = file && (file.size > 20 * 1024 * 1024 || !/\.(png|jpe?g|webp|pdf)$/i.test(file.name));
          logo.setCustomValidity(invalid ? this.dataset.fileError : '');
        };
        logo.addEventListener('change', validateLogo);
        phone.addEventListener('input', () => phone.setCustomValidity(''));
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (this.pending) return;
          validateLogo();
          let digits = phone.value.replace(/\D/g, '');
          if (digits.startsWith('90') && digits.length === 12) digits = '0' + digits.slice(2);
          if (digits.length === 10 && digits.startsWith('5')) digits = '0' + digits;
          phone.setCustomValidity(/^05\d{9}$/.test(digits) ? '' : this.dataset.phoneError);
          if (!form.reportValidity()) return;
          phone.value = digits;
          this.pending = true;
          button.disabled = true;
          button.textContent = this.dataset.adding;
          errorBox.hidden = true;
          try {
            const data = new FormData(form);
            const response = await fetch(form.action + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            window.location.assign(this.dataset.cartUrl);
          } catch (error) {
            errorBox.textContent = error.message || this.dataset.error;
            errorBox.hidden = false;
            button.disabled = false;
            button.textContent = this.dataset.add;
            this.pending = false;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
